import Vue from 'vue'
import Vuex from 'vuex'
import VuexPathify from './pathify'
import VuexPersistence from 'vuex-persist'

import ApiModule from '@/modules/ApiModule.vue'
import LoadingModule from '@/modules/LoadingModule.vue'
import ServiceWorkerModule from '@/modules/ServiceWorkerModule.vue'

Vue.use(Vuex)

const vuexPersistence = new VuexPersistence({
  reducer: (state) => ({
    ApiModule: {
      apiClient: state.ApiModule.apiClient,
      apiOperator: state.ApiModule.apiOperator,
      apiOperators: state.ApiModule.apiOperators,
      apiOperatorsFromApiJson: state.ApiModule.apiOperatorsFromApiJson,
      apiOperatorUsers: state.ApiModule.apiOperatorUsers,
      apiProfessional: state.ApiModule.apiProfessional,
      apiProfessionalSlots: state.ApiModule.apiProfessionalSlots,
      apiToken: state.ApiModule.apiToken,
      apiTokenExpiry: state.ApiModule.apiTokenExpiry,
      apiUserId: state.ApiModule.apiUserId,
      zoomAuthorised: state.ApiModule.zoomAuthorised
    }
  }),
  storage: window.localStorage,
  strictMode: process.env.NODE_ENV !== 'production'
})

const store = new Vuex.Store({
  modules: {
    ApiModule,
    LoadingModule,
    ServiceWorkerModule
  },
  mutations: {
    RESTORE_MUTATION: vuexPersistence.RESTORE_MUTATION
  },
  plugins: [
    VuexPathify.plugin,
    vuexPersistence.plugin
  ],
  strict: process.env.NODE_ENV !== 'production'
})

export default store
